import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {IHourlyWagePayload, IInitialStateHourlyWage} from "../types";
import {GetDeleteHourlyWage, GetHourlyWage} from "./thunk";


const initialState: IInitialStateHourlyWage = {
    hourlyWage: [],
    selectedHourlyWageIDs: [],
    isLoadingHourlyWage: false,
    hourlyWageRestore: [],
    isViewRestoreHourlyWage: false
}

const hourlyWageSlice = createSlice({
    name: "hourlyWage",
    initialState,
    reducers: {
        setHourlyWage: (state, action: PayloadAction<IHourlyWagePayload[]>) => {

            state.hourlyWage = action.payload;
        },
        setSelectedHourlyWageIDs: (state, action) => {
            state.selectedHourlyWageIDs = action.payload
        },
        setIsViewRestoreHourlyWage: (state) => {

            state.isViewRestoreHourlyWage = !state.isViewRestoreHourlyWage;
        },
        deletedRestoreHourlyWage: (state, action) => {
            const updateData = state.hourlyWageRestore.filter(
                (elem) => elem.id !== action.payload
            );
            state.hourlyWageRestore = updateData;
        },
        setRestoreHourlyWage: (state, action) => {
            state.hourlyWageRestore = action.payload;
        },
        updateHourlyWage: (state, action: PayloadAction<IHourlyWagePayload>) => {
            const updateData = action.payload;
            state.hourlyWage = state.hourlyWage.map((elem) => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData,
                    };
                }
                return elem;
            });
        },
        deleteHourlyWage: (state, action: PayloadAction<number>) => {
            const id = action.payload;
            const updatedData = state.hourlyWage.filter(
                (elem) => elem.id !== id
            );
            state.hourlyWage = updatedData;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(GetHourlyWage.pending, state => {
            state.isLoadingHourlyWage = true
        }).addCase(GetHourlyWage.fulfilled, state => {
            state.isLoadingHourlyWage = false
        }).addCase(GetHourlyWage.rejected, state => {
            state.isLoadingHourlyWage = false
        })
            .addCase(GetDeleteHourlyWage.pending, state => {
                state.isLoadingHourlyWage = true
            })
            .addCase(GetDeleteHourlyWage.fulfilled, state => {
                state.isLoadingHourlyWage = false
            })
            .addCase(GetDeleteHourlyWage.rejected, state => {
            state.isLoadingHourlyWage = false
        })
    }

})

export const {
    setHourlyWage,
    setSelectedHourlyWageIDs,
    updateHourlyWage,
    deleteHourlyWage,
    setIsViewRestoreHourlyWage,
    deletedRestoreHourlyWage,
    setRestoreHourlyWage
} = hourlyWageSlice.actions

export default hourlyWageSlice